import React, {useState} from 'react'
import SubHeader from '../general/SubHeader'
import { MdArrowOutward } from 'react-icons/md';
import { FaLocationDot } from 'react-icons/fa6';
import { IoCall, IoMailUnread } from 'react-icons/io5';
import CallImg from '../assets/call-img.jpg';
import { toast } from 'react-toastify';


const Contact = () => {
    const [formData, setFormData] = useState({
      name: '',
      mobile: '',
      email: '',
      message: ''
    });
  
    const handleChange = (e) => {
      const { name, value } = e.target;
      setFormData((prevState) => ({
        ...prevState,
        [name]: value
      }));
    };
  
    const handleSubmit = async (e) => {
      e.preventDefault();
  
      try {
        const response = await fetch('https://api.tradeintell.com/submit-enquiry', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(formData)
        });
  
        if (response.ok) {
                    toast.success('Thank you for getting in touch!');
          
          setFormData({
                name: '',
      mobile: '',
      email: '',
      message: ''
          })
        } else {
          throw new Error('Failed to submit form');
        }
      } catch (error) {

          toast.error('Something Went Wrong. Try again.');
      }
    };
  


  return (
    <>
        <SubHeader message='Contact Us' />

<section className='my-5'>
<div className='container'>

<div className='row'>

<div className='col-lg-8 col-12 my-2'>
<p className='fm-inter fw-bold fs-5'>Trade With Knowledge. Execute With Precision. Grow With Discipline.</p>
<div className='bg-light rounded-4 p-4 h-100'>


<form class="row g-3" onSubmit={handleSubmit}>
  <div class="col-md-6">
    <input type="text" class="contact-control" value={formData.name} name='name' onChange={handleChange} id="inputName4" placeholder='Your Name' />
  </div>
  <div class="col-md-6">
    <input type="email" class="contact-control" value={formData.email} name='email' onChange={handleChange} id="inputEmail4" placeholder='Email Address' />
  </div>

  <div class="col-12">
    <input type="tel" class="contact-control" value={formData.mobile} name='mobile' onChange={handleChange} id="inputMobile" placeholder="Mobile No" />
  </div>

  <div class="col-12">
    <textarea type="text" class="contact-control" value={formData.message} name='message' onChange={handleChange} id="inputMessage" rows={7} placeholder='Enter your Message'></textarea>
  </div>

  <div class="col-12">
<button type='submit' className='about-btn'>Send Message <MdArrowOutward size={20} /></button></div>
</form>



</div>
</div>


<div className='col-lg-4 col-12 my-2'>
  <div className='contact-right rounded-top p-4'>
        <p className='fw-semibold fm-inter my-0'>Need Any Help?</p>
        <p className='para-text'>Make a Call for Support</p>

        <hr />

<p className='fw-semibold bg-white rounded p-2'><FaLocationDot /> Hinjilicut, Odisha (761102)</p>
<p className='fw-semibold bg-white rounded p-2'><IoCall /> +91 8018532612</p>
<p className='fw-semibold bg-white rounded p-2'><IoMailUnread /> info@intell.com</p>
    </div>
    <img src={CallImg} className='img-fluid rounded-bottom' alt='Call' />
</div>


</div>
{/* row ends */}

</div>
</section>


<section className='my-5'>
  <div className='container'>
    <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d30091.08300859346!2d84.72378031591533!3d19.482048885675468!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3a3d4d306119cb33%3A0x5a14661273ea4f89!2sHinjilicut%2C%20Odisha!5e0!3m2!1sen!2sin!4v1768480275495!5m2!1sen!2sin" className='w-100 border-0' height="450"
    allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
  </div>  </section>

    </>
  )
}

export default Contact